/**
 * components/fasteners/ExplodeGuideLine.tsx — Linea guida tratteggiata
 * nella vista esplosa (richiesta utente 24-09-2026, MUTA).
 *
 * Dal centro del foro (`anchor.position`, posizione ASSEMBLATA) alla vite
 * ESPLOSA (`to`, gia' spostata lungo il proprio asse in `LockScene.tsx`):
 * mostra l'allineamento vite↔foro quando l'esploso le separa. Nessun
 * calcolo qui — riceve entrambi i punti gia' risolti (SPEC §6, AC-7).
 * Usa drei `<Line dashed>` (mai `<line>` minuscolo, collide con SVG in r3f
 * — stesso avviso di `Fastener.tsx`).*/

import { Line } from "@react-three/drei";
import { useMemo } from "react";
import * as THREE from "three";
import { COLORS } from "../../config/colors";
import { EXPLODE_DEFAULTS } from "../../config/defaults";
import type { Vec3 } from "../../data/types";

export interface ExplodeGuideLineProps {
  /** Centro del foro (posizione assemblata, non esplosa).*/
  from: Vec3;
  /** Posizione attuale della vite esplosa.*/
  to: Vec3;
}

/** Linea tratteggiata dal foro alla vite esplosa.*/
export function ExplodeGuideLine({ from, to }: ExplodeGuideLineProps) {
  const points = useMemo<[THREE.Vector3, THREE.Vector3]>(
    () => [new THREE.Vector3(...from), new THREE.Vector3(...to)],
    [from, to],
  );

  return (
    <Line
      points={points}
      color={COLORS.explodeGuide}
      dashed
      dashSize={EXPLODE_DEFAULTS.guideDash.size}
      gapSize={EXPLODE_DEFAULTS.guideDash.gap}
    />
  );
}
